export const TWCG_1489_CONNECTOR_ONBOARDING = {
	ENROLMENT_DATE: 'twcg-1489:enrolmentDate',
	SPOTLIGHT_SHOWN: 'twcg-1489:spotlightShown',
	PROMO_DISMISSED: 'twcg-1489:promoDismissed',
} as const;

export const Twcg1489ConnectorOnboardingKeys = [
	...Object.values(TWCG_1489_CONNECTOR_ONBOARDING),
] as const;
